// @flow
import client from '../../client'
import format from '../../utils/format'

// Types
import type { TrackingVehiclePosition } from '../../api_types'

// API Endpoints
export const RIDE_TRACKING = '/trackings/{0}/events/latest'
export const ONDEMAND_RIDE_TRACKING = '/ondemand/reservations/{0}/tracking/'
export type DataRequest = {
  baseUrl: string,
  id: string,
  ondemand?: boolean,
}

/**
 * Gets the position coordinates of the car for a given reservation id, along with an estimated
 * time to pickup arrival.
 * @param  {Object} data Reservation tracking information
 * @param  {string} data.id Hashed id of the reservation
 * @return {Promise|Error} A resolved Promise with tracking information for the pickup vehicle.
 */
export const getPrebookPosition = (
  data: DataRequest
): Promise<?TrackingVehiclePosition> => {
  const endpoint = format(RIDE_TRACKING, data.id)
  return client.get(endpoint, { baseUrl: data.baseUrl })
}

/**
 * Gets the position coordinates of the car for a given reservation id, along with an estimated
 * time to pickup arrival.
 * @param  {Object} data Reservation tracking information
 * @param  {string} data.id Hashed id of the reservation
 * @return {Promise|Error} A resolved Promise with tracking information for the pickup vehicle.
 */
export const getOndemandPosition = (
  data: DataRequest
): Promise<?TrackingVehiclePosition> => {
  const endpoint = format(ONDEMAND_RIDE_TRACKING, data.id)
  return client.get(endpoint)
}

const getPosition = (data: DataRequest): Promise<?TrackingVehiclePosition> =>
  data.ondemand ? getOndemandPosition(data) : getPrebookPosition(data)

export default getPosition
